import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { useQuery } from '@apollo/client';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GoogleMap, Marker } from '@react-google-maps/api';
import Slider from 'react-slick';

import { popupQuery } from '../../views/DirectoryView/GraphQLQuerys';

/**
 *
 * @param root0
 * @param root0.className
 * @param root0.onClick
 */
const NextArrow = ({ className, onClick }) => (
  <button className={className} onClick={onClick}>
    <FontAwesomeIcon icon={['fas', 'chevron-right']} />
  </button>
);

NextArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.oneOfType([PropTypes.shape(), PropTypes.func]),
};

NextArrow.defaultProps = {
  className: '',
  onClick: null,
};

/**
 *
 * @param root0
 * @param root0.className
 * @param root0.onClick
 */
const PrevArrow = ({ className, onClick }) => (
  <button className={className} onClick={onClick}>
    <FontAwesomeIcon icon={['fas', 'chevron-left']} />
  </button>
);

PrevArrow.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.oneOfType([PropTypes.shape(), PropTypes.func]),
};

PrevArrow.defaultProps = {
  className: '',
  onClick: null,
};
export default class DirectoryProductPopup extends Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {
    document.getElementById('root').style.overflow = 'hidden';
  }

  componentWillUnmount() {
    document.getElementById('root').style.overflow = 'auto';
  }

  render() {
    const { product, togglePopup } = this.props;

    const GetPopupData = () => {
      const { error, loading, data } = useQuery(popupQuery, {
        variables: { id: product },
      });

      if (error) {
        return <p>{'Something went wrong, please try again.'}</p>;
      }

      if (loading) {
        return (
          <span className="loader">
            <FontAwesomeIcon icon={['fas', 'circle-notch']} spin />
          </span>
        );
      }

      if (data) {
        const {
          productImages,
          productInformations,
          urlPrimary,
          webshopUrlPrimary,
          company: { logoUrl },
          productVideos,
          productCertificates,
          postalAddresses,
        } = data.product[0];

        const headerSliderSettings = {
          dots: false,
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true,
          autoplay: true,
          autoplaySpeed: 4000,
          draggable: true,
          cssEase: 'linear',
        };

        const sliderSettings = {
          dots: false,
          infinite: false,
          speed: 500,
          slidesToShow: 3,
          slidesToScroll: 1,
          adaptiveHeight: true,
          autoplay: false,
          autoplaySpeed: 3000,
          draggable: true,
          cssEase: 'linear',
          nextArrow: <NextArrow className="slider-next" />,
          prevArrow: <PrevArrow />,
          responsive: [
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        };

        // need to split up location string into two different values
        let { location } = postalAddresses[0];
        let latitude;
        let longitude;
        if (location) {
          location = location.replace('(', '').replace(')', '').split(',');
          latitude = Number(location[0]);
          longitude = Number(location[1]);
        }

        let description = '';
        let name = '';
        productInformations.forEach((elem) => {
          if (elem.language === 'en') {
            name = elem.name;
            description = elem.description;
          }
        });

        return (
          <div className="directoryPopup__content">
            <div className="header">
              <Slider {...headerSliderSettings}>
                {productImages.map((image, i) => {
                  const key = i;
                  const { largeUrl, altText } = image;
                  return <img loading="lazy" key={key} src={largeUrl} alt={altText} className="headerImage" />;
                })}
              </Slider>
              {logoUrl && <img loading="lazy" src={logoUrl} alt="" className="logo" />}
            </div>
            <div className="directoryPopup__content--text">
              <div className="title">
                <h1>{name}</h1>
              </div>
              <div className="description">
                <p>{description}</p>
                {productCertificates && productCertificates[0] ? (
                  <img className="productCertificatesBig" src={productCertificates[0].certificateDetails.logoUrl} />
                ) : (
                  ''
                )}
              </div>
              <div className="links">
                {urlPrimary && (
                  <a href={urlPrimary} target="_blank" rel="noopener noreferrer">
                    <span>{'Product Webpage'}</span> <FontAwesomeIcon icon={['fas', 'external-link-alt']} />
                  </a>
                )}

                {webshopUrlPrimary && (
                  <a href={webshopUrlPrimary} target="_blank" rel="noopener noreferrer">
                    <span>{'Product Webshop'}</span> <FontAwesomeIcon icon={['fas', 'external-link-alt']} />
                  </a>
                )}
              </div>
              {productImages.length > 1 && (
                <div className="images">
                  <Slider {...sliderSettings}>
                    {productImages.map((image, i) => {
                      const key = i;
                      const { largeUrl, thumbnailUrl, altText } = image;
                      return (
                        <a data-fancybox={largeUrl} href={largeUrl} key={key}>
                          <img loading="lazy" src={thumbnailUrl} alt={altText} />
                        </a>
                      );
                    })}
                  </Slider>
                </div>
              )}
              {productVideos.length > 0 && (
                <div className="videos">
                  {productVideos.map((video) => {
                    const videoUrl = video.url.replace('watch?v=', 'embed/');
                    return (
                      <div>
                        <iframe loading="lazy" title={video.title} src={videoUrl} />
                      </div>
                    );
                  })}
                </div>
              )}
              <div className="address">
                {location && (
                  <GoogleMap
                    className="address__map"
                    mapContainerStyle={{
                      width: '100%',
                      height: '300px',
                    }}
                    center={{
                      lat: latitude,
                      lng: longitude,
                    }}
                    zoom={13}
                    onLoad={(map) => {
                      this.map = map;
                    }}
                  >
                    <Marker
                      key={product.id}
                      position={{
                        lat: Number(latitude),
                        lng: Number(longitude),
                      }}
                    />
                  </GoogleMap>
                )}
                <div className="address__content">
                  <h3>{'Address:'}</h3>
                  <p>{postalAddresses[0].streetName}</p>
                  <p>{postalAddresses[0].city}</p>
                  <p>{postalAddresses[0].postalCode}</p>
                </div>
              </div>
            </div>
          </div>
        );
      }
      return null;
    };

    return (
      <div className="directoryPopup">
        <div className="directoryPopup__background" />
        <div className="directoryPopup__holder">
          <button className="directoryPopup__backButton" onClick={togglePopup}>
            <FontAwesomeIcon icon={['fas', 'chevron-left']} /> {'Back\r'}
          </button>
          <GetPopupData />
        </div>
      </div>
    );
  }
}

DirectoryProductPopup.propTypes = {
  product: PropTypes.string.isRequired,
  togglePopup: PropTypes.func.isRequired,
};
